module.exports = __webpack_public_path__ + "media/evolve/assets/icons/animated/delete-1f0fde59211f719d49a48025e877ca21.svg";